import ActionTypes from '../Actions/ActionTypes';

let initialState = {
  Templates: [],
  MyTemplates: [],
  GuestGroup: [],
  GuestList: [],
  Menu: [],
  Seating: null,
  Attendee: [],
  AttendeeDetail: null,
  RSVP: null,
  Pending:[],
  Tidbits: [
    {
      id: 1,
      answerType: 'Description',
      question: '',
      answer: null,
      options: []
    }
  ],
  Qna: [
    {
      id: 1,
      answerType: 'Description',
      question: '',
      answer: '',
    }
  ]
};

const EventPlanningReducer = (state = initialState, action) => {

  switch (action.type) {
    case ActionTypes.TEMPLATES:
      state = { ...state, Templates: action.payload };
      break;

    case ActionTypes.MY_TEMPLATES:
      state = { ...state, MyTemplates: action.payload };
      break;

    case ActionTypes.GET_GUEST_GROUP:
      state = { ...state, GuestGroup: action.payload };
      break;

    case ActionTypes.DELETE_GUEST_GROUP:
      let getGroup = [...state.GuestGroup]
      getGroup.splice(action.payload, 1)
      state = { ...state, GuestGroup: getGroup };
      break;

    case ActionTypes.GUEST_LIST:
      state = { ...state, GuestList: action.payload };
      break;

    case ActionTypes.GET_MENU:
      state = { ...state, Menu: action.payload };
      break;

    case ActionTypes.GET_SEATING:
      state = { ...state, Seating: action.payload };
      break;

    case ActionTypes.GET_ATTENDEE:
      state = { ...state, Attendee: action.payload };
      break;

      case ActionTypes.GET_PENDING:
        state = { ...state, Pending: action.payload };
        break;

    case ActionTypes.ATTENDEE_DETAIL:
      state = { ...state, AttendeeDetail: action.payload };
      break;

    case ActionTypes.SET_RSVP:
      state = { ...state, RSVP: action.payload };
      break;

    case ActionTypes.GET_TIDBITS:
      state = { ...state, Tidbits: action.payload };
      break;

    case ActionTypes.GET_QNA:
      state = { ...state, Qna: action.payload };
      break;

    case ActionTypes.CLEAR_RSVP:
      state = { ...state, RSVP: null, Tidbits: initialState.Tidbits, Qna: initialState.Qna };
      break;

    default:
      break;
  }
  return state;
};

export default EventPlanningReducer;
